import React from 'react';
import PropTypes from 'prop-types';
import { compose, lifecycle, withProps } from 'recompose';
import moment from 'moment';
import { connect } from 'react-redux';

import Details from '../ReportedTimes/components/Details';
import { withFetch } from '../../../app/entities/Entity/containers';
import { Endpoints } from '../../../app/lib/LeanLinkService';
import { withTimeplanUnits } from '../../../app/containers';
import requireProps from '../../../app/lib/requireProps';
import { bookingById } from '../../../app/entities/Booking/selectors';
import withMe from '../../containers/withMe';
import * as styles from '../ReportedTimes/styles.css';
import { TimeplanUnitRecord } from '../../../app/entities/records';
import { useTranslation } from 'react-i18next';

function MySchedule({ timeplanUnits, resourceId, secret }) {
  const { t } = useTranslation();
  return (
    <div className="row">
      <div className="col-md-4 col-md-offset-4">
        <h2 className={styles.header}>{t("Mitt schema")}</h2>
        <div className="text-center">
          <a href={Endpoints.public.calendar({ resourceId, secret })}>{t("Ladda hem schemat")}</a>
        </div>
        <p className="well well-sm text-center">{t("Här nedan visas schemat för det närmaste halvåret.")}</p>
        <Details timeplanUnits={timeplanUnits} noToggle />
        {timeplanUnits.length > 0 && (
          <div>
            <br /><br />
            <p className="well well-sm text-center">{t("Ovan visar endast den närmaste månaden, det kan finnas bokningar längre fram som inte är synliga än i denna vy")}.</p>
          </div>
        )}
        {timeplanUnits.length === 0 && (
          <p className="alert alert-info">{t("Det ligger inga bokningar under den närmaste månaden.")}</p>
        )}
      </div>
    </div>
  );
}

MySchedule.defaultProps = {
  timeplanUnits: [],
};

MySchedule.propTypes = {
  timeplanUnits: PropTypes.arrayOf(PropTypes.instanceOf(TimeplanUnitRecord)),
  resourceId: PropTypes.string.isRequired,
  secret: PropTypes.string.isRequired,
};

export default compose(
  withMe,
  withProps({
    from: moment().format('YYYY-MM-DD'),
    to: moment().add(185, 'days').format('YYYY-MM-DD'),
  }),
  withFetch(),
  lifecycle({
    componentWillMount() {
      const from = this.props.from;
      const to = this.props.to;
      this.props.fetch({
        url: Endpoints.public.resourceApi.bookedPeriods({ from, to }),
      }).then((data) => {
        if (data.entities.timeplanUnits) {
          const timeplanUnitIds = Object.keys(data.entities.timeplanUnits);
          this.setState({ timeplanUnitIds });
        } else {
          this.setState({ timeplanUnitIds: [] });
        }
      });
    },
  }),
  requireProps(['timeplanUnitIds', 'resource']),
  withProps(({ resource }) => ({
    secret: resource.get('secret'),
  })),
  withTimeplanUnits,
  connect((state, { timeplanUnits }) => ({
    timeplanUnits: timeplanUnits.map((tpu) => {
      const booking = bookingById(state, tpu.get('booking'));
      return tpu.set('customer', booking.customer);
    }),
  })),
)(MySchedule);
